import { render, staticRenderFns } from "./custom_field.vue?vue&type=template&id=c766fc3e&scoped=true"
import script from "./custom_field.vue?vue&type=script&lang=js"
export * from "./custom_field.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c766fc3e",
  null
  
)

export default component.exports